export const WORDS_PER_MINUTE = 200;
export const WORDS_PER_PAGE = 250;

export type TextLengthStats = {
  wordCount: number;
  readingTime: number;
  pageCount: number;
};

export function countWords(text: string): number {
  const trimmed = text.trim();
  if (!trimmed) {
    return 0;
  }
  return trimmed.split(/\s+/).filter((word) => word.length > 0).length;
}

export function calculateReadingTime(wordCount: number): number {
  return wordCount === 0 ? 0 : Math.ceil(wordCount / WORDS_PER_MINUTE);
}

export function estimatePages(wordCount: number): number {
  return wordCount === 0 ? 0 : Math.ceil(wordCount / WORDS_PER_PAGE);
}

export function getTextLengthStats(text: string): TextLengthStats {
  const wordCount = countWords(text);
  return {
    wordCount,
    readingTime: calculateReadingTime(wordCount),
    pageCount: estimatePages(wordCount),
  };
}

export function formatTextLengthStatLabels(
  stats: TextLengthStats,
  t: (key: string) => string,
): { words: string; minutes: string; pages: string } {
  return {
    words: `${stats.wordCount} ${stats.wordCount === 1 ? t('word') : t('word_plural')}`,
    minutes: `${stats.readingTime} ${stats.readingTime === 1 ? t('min') : t('mins')}`,
    pages: `${stats.pageCount} ${stats.pageCount === 1 ? t('page') : t('pages')}`,
  };
}

export function takeFirstWords(text: string, maxWords: number): string {
  const words = text.trim().split(/\s+/).filter((word) => word.length > 0);
  return words.slice(0, maxWords).join(' ');
}
